import { FC } from "react";
import { Stack, Text, Title } from "@mantine/core";

import { HoverCopyButton } from "@shared/components";

import { formatRuleName } from "../../../utils/ruleName";
import type { RuleTitleProps } from "../RuleTitle";

export const SecretsRuleTitle: FC<RuleTitleProps> = ({ finding }) => {
  return (
    <Stack gap={2}>
      <HoverCopyButton
        copyText={finding.rulePath}
        tooltipText="Copy full rule name"
      >
        <Title lineClamp={1} fz="lg" order={5}>
          {formatRuleName(finding.rulePath ?? "")}
        </Title>
      </HoverCopyButton>
      <Text c="gray.6" fz="sm">
        {finding.secretsAttributes?.secretType}
      </Text>
    </Stack>
  );
};
